import React, { useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import { Button, App } from 'antd';
import { InsMonitorModel } from '@/types/home';
import { imgUrl } from '@/shared/utils';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { AppSettings } from '@/shared/app-common';
import { fetchInsMonitorListDemo } from '@/lib/service';
import Image from 'next/image';

const RightSideContent = () => {
  const [demoAccountData, setDemoAccountData] = useState<InsMonitorModel[]>([]);
  const { t } = useTranslation();
  const router = useRouter();
  const { message } = App.useApp();
  const ref = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.style.backgroundImage = `url('https://res-front.pumpsoul.com/ins-prod/image/banner.webp')`;
          observer.unobserve(element); // 停止观察
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

  const fetchData = () => {
    fetchInsMonitorListDemo(router.locale)
      .then((res) => {
        if (res.code === 0) {
          setDemoAccountData(res.data);
        } else {
          message.error(res.message);
        }
      })
      .catch((error) => {
        message.error(error.message);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchData();
    }, 100);
  }, []);

  const onLinkDemoAccount = (accoutn: InsMonitorModel) => {
    if (!accoutn) return;
    router.push(
      `${AppSettings.webHost}/analytics/${accoutn?.identification}?name=${accoutn?.media_name}&identification=${accoutn?.identification}&avatar=${accoutn?.avatar}`
    );
  };

  const demoAccountList = useMemo(() => {
    return demoAccountData.map((account) => {
      return (
        <div className={styles.accountItem} key={account.identification}>
          <Image className={styles.avatar} src={imgUrl(account.avatar, 'mid')} alt="" width={45} height={45} />
          <div className={styles.rightContents}>
            <div className={styles.accountName}>{account.media_name}</div>
            <div className={styles.linkButton} onClick={() => onLinkDemoAccount(account)}>
              {t('See Analytics')}
              {' >'}
            </div>
          </div>
        </div>
      );
    });
  }, [demoAccountData]);

  const getContent = useMemo(() => {
    return (
      <div className={styles.rightContent}>
        <div ref={ref} className={styles.nav} style={{ backgroundColor: '#fff' }}>
          <div className={styles.title}>{t('Your Ultimate Instagram Activity Tracker')}</div>
          <Button className={styles.button} onClick={() => router.push(`${AppSettings.webHost}`)}>
            {t('Start tracking')}
          </Button>
        </div>

        <div className={styles.sampleAccountContent} style={{ backgroundColor: '#fff' }}>
          <div className={styles.title}>{t('Track Any Instagram Account')}</div>
          <div className={styles.desc}>
            {t("Select an Instagram Activity Sample Report below to see what you'll get")}
          </div>
          <div className={styles.accountList}>{demoAccountList}</div>
        </div>
      </div>
    );
  }, [demoAccountList]);

  return <>{getContent}</>;
};

export default RightSideContent;
